/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { FETCH_STATUSES } from 'utils/fetchStatusUtils';
import LoanOfficerRepository from 'repositories/administrators/LoanOfficersRepository';
import LoanOfficerApproveProfileRepository from 'repositories/administrators/LoanOfficerApproveProfileRepository';

const initialState = {
  loanOfficerUpdatingStatus: FETCH_STATUSES.idle,
  loanOfficerApprovingStatus: FETCH_STATUSES.idle,
};

const administratorsLoanOfficerSlice = createSlice({
  name: 'administratorsLoanOfficerSlice',
  initialState,
  reducers: {
    updateLoanOfficerStart(state) {
      state.loanOfficerUpdatingStatus = FETCH_STATUSES.pending;
    },
    updateLoanOfficerFinish(state) {
      state.loanOfficerUpdatingStatus = FETCH_STATUSES.fulfilled;
    },
    updateLoanOfficerFail(state) {
      state.loanOfficerUpdatingStatus = FETCH_STATUSES.failed;
    },
    approveLoanOfficerStart(state) {
      state.loanOfficerApprovingStatus = FETCH_STATUSES.pending;
    },
    approveLoanOfficerFinish(state) {
      state.loanOfficerApprovingStatus = FETCH_STATUSES.fulfilled;
    },
    approveLoanOfficerFail(state) {
      state.loanOfficerApprovingStatus = FETCH_STATUSES.failed;
    },
  },
});

export const { actions } = administratorsLoanOfficerSlice;

export default administratorsLoanOfficerSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const updateLoanOfficer = async attrs => {
    dispatch(actions.updateLoanOfficerStart());
    try {
      const response = await LoanOfficerRepository.update(attrs);
      dispatch(actions.updateLoanOfficerFinish());
      return response;
    } catch (error) {
      dispatch(actions.updateLoanOfficerFail());
      throw error;
    }
  };

  const approveLoanOfficer = async params => {
    dispatch(actions.approveLoanOfficerStart());
    try {
      const response = await LoanOfficerApproveProfileRepository.create(params);
      dispatch(actions.approveLoanOfficerFinish());
      return response;
    } catch (error) {
      dispatch(actions.approveLoanOfficerFail());
      throw error;
    }
  };

  return {
    updateLoanOfficer,
    approveLoanOfficer,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/administrators/loanOfficerSlice.js